<template>
  <component
    :is="component"
    v-if="component"
    v-bind="data"
  />
</template>

<script>
// import RslLoader from '@RSL/RslLoader'

export default {
    props: {
        data: {
            type: Object,
            default: () => {}
        },
        path: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            component: null
        };
    },
    computed: {
        loader() {
            if (!this.path) {
                return null;
            }
            return () => ({
                // The component to load. Should be a Promise
                component: import(`@/components/${this.path}.vue`),
                // A component to use while the async component is loading
                // loading: RslLoader,
                // A component to use if the load fails
                // error: ErrorComp,
                // Delay before showing the loading component. Default: 200ms.
                // delay: 100,
                // The error component will be displayed if a timeout is
                // provided and exceeded. Default: Infinity.
                timeout: 3000
            });
        }
    },
    async created() {
        try {
            await this.loader();
            this.component = () => this.loader();
        } catch (err) {
            throw err;
        }
    }
};
</script>
